import { createFileRoute, redirect } from '@tanstack/react-router';
import { SettingsPage } from '@/features/marketing';
import {
  isSectionMovedToIntegrations,
  resolveSectionKey,
  type SettingsSectionKey,
} from '@/features/marketing/settings/settings-section-keys';

type SettingsSearch = { section: SettingsSectionKey };

export const Route = createFileRoute('/_auth/$orgId/marketing/settings')({
  validateSearch: (search: Record<string, unknown>): SettingsSearch => ({
    section: resolveSectionKey(search.section),
  }),
  // Read the raw query: `validateSearch` already coerced a moved section to the default one.
  beforeLoad: ({ params, location }) => {
    if (isSectionMovedToIntegrations(new URLSearchParams(location.searchStr).get('section'))) {
      throw redirect({ to: '/$orgId/settings/integrations', params, replace: true });
    }
  },
  component: SettingsRoute,
});

function SettingsRoute() {
  const { orgId } = Route.useParams();
  const { section } = Route.useSearch();
  return <SettingsPage orgId={orgId} section={section} />;
}
